<div class="row pr-0">
    <div class="col-12 pr-0">

        <div class="controls">
            <button [ngClass]="{typeMapIdSelected: typeMapIdSelect =='satellite'}" (click)='changeTypeMap("satellite")'
                class="typeMapId">satellite</button>
            <button [ngClass]="{typeMapIdSelected: typeMapIdSelect =='hybrid'}" (click)='changeTypeMap("hybrid")'
                class="typeMapId">hybrid </button>
            <button [ngClass]="{typeMapIdSelected: typeMapIdSelect =='roadmap'}" (click)='changeTypeMap("roadmap")'
                class="typeMapId">roadmap</button>
            <button [ngClass]="{typeMapIdSelected: typeMapIdSelect =='terrain'}" (click)='changeTypeMap("terrain")'
                class="typeMapId">terrain</button>
        </div>

        <div class="controlsSimulation pl-3">
            <simple-notifications [options]="options"></simple-notifications>

            <button class="d-none" placement="bottom" ngbTooltip="Lent" mat-mini-fab style="background-color: white;" (click)="slow()">
                <mat-icon>fast_rewind</mat-icon>
            </button> &nbsp;
            <button  placement="bottom" ngbTooltip="Play" mat-mini-fab style="background-color: white;" (click)="play()">
                <mat-icon>play_circle_outline</mat-icon>
            </button> &nbsp;
            <button placement="bottom" ngbTooltip="Pause" mat-mini-fab style="background-color: white;"
                (click)="pause()">
                <mat-icon>pause_circle_outline</mat-icon>
            </button> &nbsp;
            <button placement="bottom" ngbTooltip="Réinitialiser" mat-mini-fab style="background-color: white;"
                (click)="reset()">
                <mat-icon> format_color_reset</mat-icon>
            </button> &nbsp;
            <button placement="bottom" ngbTooltip="Précédent" mat-mini-fab style="background-color: white;"
                (click)="prev()">
                <mat-icon>skip_previous</mat-icon>
            </button> &nbsp;
            <button placement="bottom" ngbTooltip="Suivant" mat-mini-fab style="background-color: white; "
                (click)="next()">
                <mat-icon>skip_next</mat-icon>
            </button> &nbsp;
            <button class="d-none" placement="bottom" ngbTooltip="Rapide" mat-mini-fab style="background-color: white;"
                (click)="fast()">
                <mat-icon>fast_forward</mat-icon>
            </button>&nbsp;


            <button class="d-none" placement="bottom" ngbTooltip="Lent" mat-mini-fab style="background-color: white; "
                (click)="slow()">
                <span id="speed" style="color: #3b5876 ;">{{ speedMultiplier }}x</span>
            </button> &nbsp;

        </div>
   
        <div class="controlsOptions2">
            <button type="button" class="btn mr-2" style="width: 50px;
height: 50px;
background-size: 70px;
background: url(https://www.middleeasteye.net/sites/default/files/styles/article_page/public/GoogleMap.15August2016.Google.png?itok=xahxUK6K) no-repeat;
    background-size: auto;
background-size: auto 50px;" (click)="changeStyleMap('darkStyle2')"></button>
            <br>
            <button type="button" class="btn " style="width: 50px;
height: 50px;
background-size: 70px;
background: url(https://www.androidpolice.com/wp-content/uploads/2020/06/22/Dark-Mode-maps-in-Google-App-hero.png) no-repeat;
    background-size: auto;
background-size: auto 50px;" (click)="changeStyleMap('darkStyle')"></button>

        </div>

        <agm-map [styles]="style" [fullscreenControl]="true" [disableDefaultUI]="false" [zoomControl]="true"
            [mapTypeId]="typeMapIdSelect" [usePanning]="true" [streetViewControl]="true" [rotateControl]="true"
            [scaleControl]="true" [mapTypeId]="typeMapIdSelect" [latitude]="start" [longitude]="end" [zoom]="zoom"
            (mapReady)="onMapReady($event)">

            <agm-marker [latitude]="start" [longitude]="end"
                [iconUrl]="{  url: 'https://www.snc.fr/images/trintervt3.gif',  scaledSize: {  width: 60,  height: 80  }}">

            </agm-marker>
            <agm-marker [latitude]="startend" [longitude]="endIcon"
                [iconUrl]="{  url: 'https://upload.wikimedia.org/wikipedia/commons/9/98/RCli_A_BAL_F.gif',  scaledSize: {  width: 50,  height: 80  }}">

            </agm-marker>

            <agm-circle [latitude]="accidentStart" [longitude]="accidentEnd" [radius]="17" [fillColor]="'red'"
                [circleDraggable]="false" [editable]="true">
            </agm-circle>

        </agm-map>

    </div>

</div>